import request from "@/utils/http";
import qs from "qs"; // 根据需求是否导入qs模块

// 微信签名
export function weiXingSDK(url) {
  return request.get(`/wx/wxJsapiSignature?url=${url}`).then(res => {
    return res.result;
  });
}

// 经销商授权登录 作废
export function logins(code) {
  return request.post("/auth/login", qs.stringify({ code: code }));
}

// 经销商密码登录 作废
export function login(data) {
  return request.post("/auth/login/password", data);
}

// 商户登录 (新增)
export function phone_captcha(data) {
  return request.post("/merchant/login/phone_captcha", data);
}

// 商户登录 (微信登录新增)
export function wechat(code) {
  return request.post("/merchant/login/wechat", qs.stringify({
    code: code
  }));
}


// 用户信息
export function userInfo() {
  return request.get("/user/info/base");
}

// 用户信息 新增
export function base_info() {
  return request.get("/merchant/base_info");
}

// 解绑微信
export function unbindWx() {
  return request.post("/auth/unbindWx");
}

// 注销
export function logout() {
  return request.post("/auth/logout");
}

// 验证码 作废
export function captcha(phone) {
  return request.post(`/auth/change-pwd-with-phone/captcha/sms?phone=${phone}`);
}

// 获取手机验证码 (新增)
export function send(phone) {
  return request.post(`/merchant/login/phone_captcha/send?phone=${phone}`);
}

// 设置密码
export function setPassword(data) {
  return request.post(
    `/auth/change-pwd-with-phone?phone=${data.phone}&password=${data.password}&captcha=${data.captcha}`
  );
}

// 更新经销商资料
export function updateDealer(data) {
  return request.post("/user/updateDealer", data);
}